export default __webpack_public_path__ + "static/media/Export_footer.2e654c25.svg";